import { BoltIcon } from "@heroicons/react/20/solid";
import { Outlet, useNavigate } from "react-router-dom";
import SignalTabs from "./components/SignalTabs";
import { Button, Flex } from "@mantine/core";

const SignalsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 overflow-auto relative h-full bg-gray-100">
      <div className="mx-auto">
        <Flex justify="space-between" align="center" mb={10}>
          <SignalTabs />
          <Button
              size="sm"
              onClick={() => navigate("new")}
              color="white"
              className="text-sm"
              leftSection={<BoltIcon className="w-4 h-4" />}
          >
              New Signal
          </Button>
        </Flex>
        <div className="py-1 bg-white border-2 border-gray-200 rounded-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SignalsPage;
